import * as __SNOWPACK_ENV__ from './_snowpack/env.js';
import.meta.env = __SNOWPACK_ENV__;

import './App.svelte.css';
/* src/App.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "./_snowpack/pkg/svelte/internal.js";

import Grid from "./Grid.svelte.js";
import Palette from "./Palette.svelte.js";
import Passwd from "./Passwd.svelte.js";
import Result from "./Result.svelte.js";
import * as lib from "./encoder.js";

function create_if_block_1(ctx) {
	let h3;

	return {
		c() {
			h3 = element("h3");
			h3.textContent = "DON'T USE THIS WALLET YET! It's unfinished, so the exact algo can change.";
			attr(h3, "class", "warning svelte-1w4rmlq");
		},
		m(target, anchor) {
			insert(target, h3, anchor);
		},
		d(detaching) {
			if (detaching) detach(h3);
		}
	};
}

// (110:4) {#if showResult}
function create_if_block(ctx) {
	let result_1;
	let current;
	result_1 = new Result({ props: { result: /*result*/ ctx[3] } });
	result_1.$on("close", /*closeResult*/ ctx[11]);

	return {
		c() {
			create_component(result_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(result_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const result_1_changes = {};
			if (dirty & /*result*/ 8) result_1_changes.result = /*result*/ ctx[3];
			result_1.$set(result_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(result_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(result_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(result_1, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let h2;
	let t1;
	let t2;
	let grid;
	let t3;
	let palette;
	let t4;
	let passwd;
	let t5;
	let div0;
	let t7;
	let current;
	let mounted;
	let dispose;
	let if_block0 = !/*dev*/ ctx[5] && create_if_block_1(ctx);

	grid = new Grid({
			props: {
				color: /*color*/ ctx[0],
				enc_data: /*enc_data*/ ctx[1],
				pv: /*passVisable*/ ctx[2]
			}
		});

	grid.$on("update", /*onGrid*/ ctx[7]);
	palette = new Palette({});
	palette.$on("colorSelect", /*onColor*/ ctx[6]);
	passwd = new Passwd({});
	passwd.$on("update", /*onPasswd*/ ctx[8]);
	passwd.$on("visable", /*onPassVisable*/ ctx[9]);
	let if_block1 = /*showResult*/ ctx[4] && create_if_block(ctx);

	return {
		c() {
			div1 = element("div");
			h2 = element("h2");
			h2.textContent = "Super Brain Wallet";
			t1 = space();
			if (if_block0) if_block0.c();
			t2 = space();
			create_component(grid.$$.fragment);
			t3 = space();
			create_component(palette.$$.fragment);
			t4 = space();
			create_component(passwd.$$.fragment);
			t5 = space();
			div0 = element("div");
			div0.textContent = "GENERATE";
			t7 = space();
			if (if_block1) if_block1.c();
			attr(h2, "class", "svelte-1w4rmlq");
			attr(div0, "class", "generate svelte-1w4rmlq");
			attr(div1, "class", "App svelte-1w4rmlq");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, h2);
			append(div1, t1);
			if (if_block0) if_block0.m(div1, null);
			append(div1, t2);
			mount_component(grid, div1, null);
			append(div1, t3);
			mount_component(palette, div1, null);
			append(div1, t4);
			mount_component(passwd, div1, null);
			append(div1, t5);
			append(div1, div0);
			append(div1, t7);
			if (if_block1) if_block1.m(div1, null);
			current = true;

			if (!mounted) {
				dispose = listen(div0, "click", /*generate*/ ctx[10]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			const grid_changes = {};
			if (dirty & /*color*/ 1) grid_changes.color = /*color*/ ctx[0];
			if (dirty & /*enc_data*/ 2) grid_changes.enc_data = /*enc_data*/ ctx[1];
			if (dirty & /*passVisable*/ 4) grid_changes.pv = /*passVisable*/ ctx[2];
			grid.$set(grid_changes);

			if (/*showResult*/ ctx[4]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*showResult*/ 16) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(grid.$$.fragment, local);
			transition_in(palette.$$.fragment, local);
			transition_in(passwd.$$.fragment, local);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(grid.$$.fragment, local);
			transition_out(palette.$$.fragment, local);
			transition_out(passwd.$$.fragment, local);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block0) if_block0.d();
			destroy_component(grid);
			destroy_component(palette);
			destroy_component(passwd);
			if (if_block1) if_block1.d();
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	undefined /* [snowpack] import.meta.hot */ ;
	let color = 15; // Default color index
	let color_data = []; // Base color data
	let enc_data = []; // Pass protected color data
	let key_data = [];
	let pass = '';
	let passVisable = true;
	let result = { hex: '', seed: [] };
	let showResult = false;
	let dev = __SNOWPACK_ENV__.MODE === 'development';

	function onColor(event) {
		$$invalidate(0, color = event.detail.index);
	}

	function onGrid(event) {
		color_data = event.detail.data;
		update();
	}

	function onPasswd(event) {
		pass = event.detail.value;
		update();
	}

	function onPassVisable(event) {
		$$invalidate(2, passVisable = event.detail.value);
	}

	async function update() {
		let base = lib.colorsToBits(color_data);
		let mod = await lib.passToBits2(pass);
		let res = lib.XOR(base, mod);
		$$invalidate(1, enc_data = lib.bitsToColors(res));
		let hex = lib.bitsToHexKey(res);
		let seed = await lib.bitsToSeedPhrase(res);
		console.log(hex);
		console.log(seed);
		$$invalidate(3, result = { hex, seed });
	}

	function generate() {
		if (!pass.length) {
			return alert(`Password cannot be empty`);
		}

		if (color_data.every(x => x.color === 15)) {
			return alert(`Empty image is not very secure...`);
		}

		$$invalidate(4, showResult = true);
	}

	function closeResult() {
		$$invalidate(4, showResult = false);
	}

	return [
		color,
		enc_data,
		passVisable,
		result,
		showResult,
		dev,
		onColor,
		onGrid,
		onPasswd,
		onPassVisable,
		generate,
		closeResult
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;